import { get, post, del } from 'utils/methods';

export function getFormVersionsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}form-versions`, data, headers);
}

export function deleteFormVersionsApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_PP}commands/form-version`, data, headers);
}

export function toggleFormVersionStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/form-version/status`, data, headers);
}

export function createJobResultsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/job-palette`, data, headers);
}

export function reportJobErrorApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/error`, data, headers);
}
